import styled from "styled-components"
import { Link } from "react-router-dom"

export const Container = styled.div`
    background-color: var(--darkGrey);
    min-height: calc(100vh - 50px);
    position: sticky;
    top: 50px;
`

export const Wrapper = styled.div`
    padding: 20px;
    color: var(--white);
`

export const Menu = styled.div`
    margin-bottom: 10px;
`

export const Title = styled.h3`
`

export const List = styled.ul`
    list-style: none;
    padding: 5px;
    font-size: var(--fontS);
`

export const ListItem = styled.li`
    padding: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 10px;

    :hover {
        background-color: var(--primary);
        opacity: 0.8;
    }
`

export const Icons = styled.div`
    margin-right: 5px;
`

export const StyledLink = styled(Link)`
    width: 100%;
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: center;
`